import { Injectable } from '@angular/core';
import { HttpClient } from '../shared/http-client';
import { Observable } from 'rxjs';
import 'rxjs/add/operator/map'

import { ParametroViewModel } from '../models/viewmodels/parametroViewModel';

@Injectable()
export class ParametroService {

  constructor(private httpClient: HttpClient) { }

  listado(): Observable<ParametroViewModel[]> {    
    return this.httpClient.get(`/parametros/`)
      .map(response => {
        return response.json();
      });
  }

  actualizar(parametros:Array<ParametroViewModel>){
    return this.httpClient.put('/parametros/', parametros);
  }
}



// WEBPACK FOOTER //
// C:/Source/eSoftCereal.API/eSoftCereal.UI/src/app/services/parametro.service.ts